import { ReactElement, useContext } from 'react';
import { FeatureAppLoader } from '@feature-hub/react';
import { beforeCreate } from '@/util/feature-hub';
import { GiveawayContext } from '@/state/state';
import { useFeatureServices } from '@/contexts/FeatureServicesContext';
import { FeatureService } from '@/enums/FeatureServiceDefinition';
import { extractMyDealerId } from '@/util/dealer-data';

export const DealerSearchDetailFA = (): ReactElement | null => {
  const giveawayResponse = useContext(GiveawayContext);
  const { dealerId } = giveawayResponse;
  const featureAppService = useFeatureServices()[FeatureService.FEATURE_APP_SERVICE];
  const featureAppId = 'Dealer Details';
  const featureAppName = 'Digital Giveaway';

  if (!featureAppService) {
    return null;
  }

  const { src, serverSrc, baseUrl, config } =
    featureAppService.featureAppConfigurations[featureAppId];

  const contentConfig = {
    appModeDetail: 'OVERVIEW',
    dealerId: extractMyDealerId(dealerId),
    layerLayout: 'false',
  };

  return (
    <FeatureAppLoader
      featureAppId={`${featureAppName}@${featureAppId}`}
      // Feature app name must be provided in order for api-key-provider to work correctly
      featureAppName={featureAppId}
      baseUrl={baseUrl}
      src={src}
      serverSrc={serverSrc}
      config={config}
      beforeCreate={beforeCreate(contentConfig)}
    />
  );
};
